import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'callback',
  standalone: false,
})
export class CallbackPipe implements PipeTransform {
  transform = (items: unknown[], callbackFn: (item: unknown) => boolean): unknown => {
    if (!items || !callbackFn) {
      return items
    }
    return items.filter(item => callbackFn(item))
  }
}
